import { createBrowserHistory } from "history";

// Browser history
const history = createBrowserHistory();

export default history;
